module.exports = "<div data-html-load=\"pagination-top\"></div>\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/cigna_csg_gsg_elasticsearch/src/js/views/pagination-top.tpl.html
// module id = zFaZ
// module chunks = 4